import {notification} from "antd";

const NotificationService = {}

NotificationService.success = (message) => {
  notification.success({
    message,
    duration: 3
  })
}

NotificationService.error = (message) => {
  notification.error({
    message,
    duration: 3
  })
}

export default NotificationService